import React, { ReactElement, FunctionComponent } from 'react'
import BasicText, { BasicTextProps } from '../BasicText'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type SmallBodyProps = Pick<
    BasicTextProps,
    | 'color'
    | 'textAlign'
    | 'numberOfLines'
    | 'bold'
    | 'paddingLeft'
    | 'paddingRight'
    | 'paddingTop'
    | 'paddingBottom'
    | 'webHeadlineType'
> & {
    children: string
} & TestID

const SmallBodyFont: FunctionComponent<SmallBodyProps> = ({
    children,
    color,
    textAlign,
    numberOfLines,
    bold,
    webHeadlineType,
    testID,
    paddingLeft,
    paddingRight,
    paddingBottom,
    paddingTop,
}): ReactElement => {
    return (
        <BasicText
            fontSize="FS14"
            lineHeight="LH20"
            {...{
                color,
                textAlign,
                numberOfLines,
                bold,
                webHeadlineType,
                testID,
                paddingRight,
                paddingLeft,
                paddingBottom,
                paddingTop,
            }}
        >
            {children}
        </BasicText>
    )
}

export default SmallBodyFont
